import { useState } from "react";
import "./Captacion.scss";

function Captacion() {
  const [formulario, setFormulario] = useState({
    nombre: "",
    whatsapp: "",
    tema: "",
    consulta: "",
  });

  const handleChange = (e) => {
    setFormulario({
      ...formulario,
      [e.target.name]: e.target.value,
    });
  };

  const consultarWhatsApp = (e) => {
    e.preventDefault();

    const {
      nombre,
      whatsapp,
      tema,
      consulta,
    } = formulario;

    if (!nombre || !whatsapp || !tema || !consulta) {
      alert("Por favor completá todos los campos.");
      return;
    }

    // Número de WhatsApp de la abogada
    // Formato internacional sin +, espacios ni guiones
    const numeroAbogada = "5492954396316";

    const mensaje = `
Hola Dra., quiero realizar una consulta.

*Nombre:* ${nombre}

*WhatsApp:* ${whatsapp}

*Tema:* ${tema}

*Consulta:*
${consulta}
    `;

    const url = `https://wa.me/${numeroAbogada}?text=${encodeURIComponent(
      mensaje
    )}`;

    window.open(url, "_blank");
  };

  return (
    <section className="captacion">

      <div className="captacion-container">

        {/* ENCABEZADO */}

        <div className="captacion-header">

          <span className="captacion-label">
            ASESORAMIENTO LEGAL
          </span>

          <h2>
            Contame tu caso
          </h2>

          <p>
            Completá el formulario y
            comunicate directamente por WhatsApp.
          </p>

        </div>


        {/* FORMULARIO */}

        <form
          className="captacion-form"
          onSubmit={consultarWhatsApp}
        >

          {/* NOMBRE */}

          <div className="campo">

            <label htmlFor="nombre">
              Nombre
            </label>

            <input
              id="nombre"
              name="nombre"
              type="text"
              placeholder="Tu nombre"
              value={formulario.nombre}
              onChange={handleChange}
            />

          </div>


          {/* WHATSAPP */}

          <div className="campo">

            <label htmlFor="whatsapp">
              WhatsApp
            </label>

            <input
              id="whatsapp"
              name="whatsapp"
              type="tel"
              placeholder="Ej: 2954 123456"
              value={formulario.whatsapp}
              onChange={handleChange}
            />

          </div>


          {/* TEMA */}

          <div className="campo">

            <label htmlFor="tema">
              Tema de consulta
            </label>

            <select
              id="tema"
              name="tema"
              value={formulario.tema}
              onChange={handleChange}
            >

              <option value="">
                Seleccioná un tema
              </option>

              <option value="Derecho de Familia">
                Derecho de Familia
              </option>

              <option value="Divorcio">
                Divorcio
              </option>

              <option value="Alimentos">
                Alimentos
              </option>

              <option value="Sucesiones">
                Sucesiones
              </option>

              <option value="Derecho Laboral">
                Derecho Laboral
              </option>

              <option value="Derecho Civil">
                Derecho Civil
              </option>

              <option value="Otro">
                Otro
              </option>

            </select>

          </div>


          {/* CONSULTA */}

          <div className="campo">

            <label htmlFor="consulta">
              Contame brevemente tu situación
            </label>

            <textarea
              id="consulta"
              name="consulta"
              rows="6"
              placeholder="Escribí brevemente qué necesitás consultar..."
              value={formulario.consulta}
              onChange={handleChange}
            />

          </div>


          {/* BOTÓN */}

          <button
            type="submit"
            className="btn-whatsapp"
          >

            <span className="whatsapp-icon">
              ☎
            </span>

            CONSULTAR POR WHATSAPP

            <span className="arrow">
              →
            </span>

          </button>


          <p className="aviso">

            La información enviada será utilizada
            únicamente para responder tu consulta.

          </p>

        </form>

      </div>

    </section>
  );
}

export default Captacion;